import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexOtherRequestRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/other_requests', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const createOtherRequestRequest = ({ dispatch, params, formData, callback, successCallback }) =>
  ApiService.request('post', '/other_requests', {
    dispatch,
    params,
    callback,
    formData,
    successCallback
  });

export const updateOtherRequestRequest = (id, { dispatch, params, formData, failureCallback, successCallback }) =>
  ApiService.request('put', `/other_requests/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    failureCallback
  });

export const deleteOtherRequestRequest = (id, { dispatch, failureCallback, successCallback, callback }) =>
  ApiService.request('delete', `/other_requests/${id}`, {
    dispatch,
    failureCallback,
    successCallback,
    callback
  });

export const approveOtherRequestRequest = (id, { dispatch, params, failureCallback, successCallback, callback }) =>
  ApiService.request('post', `/other_requests/${id}/approve`, {
    dispatch,
    params,
    failureCallback,
    successCallback,
    callback
  });

export const rejectOtherRequestRequest = (id, { dispatch, params, failureCallback, successCallback, callback }) =>
  ApiService.request('post', `/other_requests/${id}/reject`, {
    dispatch,
    params,
    failureCallback,
    successCallback,
    callback
  });

export const exportOtherRequestRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/other_requests/export.xlsx', {
    dispatch,
    params,
    failureCallback,
    responseType: 'text',
    successCallback
  });

export const debounceIndexOtherRequestRequest = AwesomeDebouncePromise(indexOtherRequestRequest, 300);